export class UserNotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UserNotFoundError';
    Object.setPrototypeOf(this, UserNotFoundError.prototype);
  }
}

export interface SignUpAttributes {
  displayName: string;
}

// CIAM picks the method per user: 'oob' (email OTP) for regular customers,
// 'password' only for accounts created with a local emailAddress identity
// (e.g. the store-review account).
export type SignInMethod = 'oob' | 'password';
export type SocialIdentityProvider = 'Google' | 'Apple';

export interface SignInChallenge {
  method: SignInMethod;
  codeLength: number;
}

export interface SignUpContinueResponse {
  continuation_token?: string;
  required_attributes?: { name: string; type: string; required: boolean }[];
  error?: string;
  error_description?: string;
  suberror?: string;
}

export interface InitiateResponse {
  continuation_token?: string;
  challenge_type?: string;
  error?: string;
  error_description?: string;
  suberror?: string;
}

export interface ChallengeResponse {
  continuation_token?: string;
  challenge_type?: string;
  binding_method?: string;
  code_length?: number;
  interval?: number;
  error?: string;
  error_description?: string;
  suberror?: string;
}

export interface TokenResponse {
  access_token: string;
  id_token?: string;
  refresh_token?: string;
  token_type?: string;
  scope?: string;
  expires_in: number;
  ext_expires_in?: number;
  client_info?: string;
  error?: string;
  error_description?: string;
  suberror?: string;
}
